import { frontendURL } from 'dashboard/helper/URLHelper';
import ConversationView from '../conversation/ConversationView.vue';

// custom (equipe interna): "Caixa de Entrada" = lista de conversas da EQUIPE INTERNA
// (internal_scope='only', aplicado pelo CwCustom::ConversationFinderDecorator). Reutiliza o
// ConversationView do core (importar ≠ editar): mesma tela de "Conversas", mas o ChatList
// deriva o escopo 'only' do route.name (ver ChatList.vue: INTERNAL_SCOPE_ROUTES). inboxId: 0
// mantém o ChatList em modo "todas as inboxes" — o filtro de visão é feito pelo escopo, não
// por inbox. Gated por dados: sem blocklist/inbox interna semeada, a lista fica idêntica a
// "Conversas" (no-op). O item de menu já é gated por CRM ligado na Sidebar.
const CONVERSATION_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const equipeRoutes = [
  {
    path: frontendURL('accounts/:accountId/equipe'),
    name: 'crm_internal_inbox',
    component: ConversationView,
    meta: {
      permissions: CONVERSATION_PERMISSIONS,
    },
    props: () => ({ inboxId: 0 }),
  },
  {
    path: frontendURL(
      'accounts/:accountId/equipe/conversations/:conversation_id'
    ),
    name: 'crm_internal_inbox_conversation',
    component: ConversationView,
    meta: {
      permissions: CONVERSATION_PERMISSIONS,
    },
    props: route => ({
      inboxId: 0,
      conversationId: route.params.conversation_id,
    }),
  },
];
